export default __webpack_public_path__ + "static/media/round-arrow-white.1f6773f2.svg";